import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideMenuComponent } from './shared/components/side-menu/side-menu.component';
import { Toast, ToastModule } from 'primeng/toast';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet,
    ToastModule,
    Toast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'In2Padel | Backoffice';
  constructor(private titleService: Title){

  }

  ngOnInit() {
    this.titleService.setTitle('In2Padel | Backoffice');
  }
}
